import { LocalStorageHandler } from '../utils/LocalStorageHandler';
import { useQuery } from '@tanstack/react-query';
import { useMemo } from 'react';
import { getUser } from '../api/users';

export function useProfile() {
  const viewType = LocalStorageHandler.get('view-selected') ?? 'Standard';
  const user_role = LocalStorageHandler.get<number>('userRole') ?? 0;

  const { data, error, isLoading } = useQuery({
    queryKey: ['profile'],
    queryFn: () => getUser('profile'),
  });

  if (error) {
    LocalStorageHandler.save('userRole', 0);
  }

  if (data) {
    LocalStorageHandler.save('userRole', data.user_role);
    if (data.team_id) {
      LocalStorageHandler.save('teamId', data.team_id);
    }
  }

  const memoizedUserData = useMemo(
    () => ({
      viewType,
      user_role,
      ...data,
      show_config: !isLoading && data?.user_role >= 1000,
      // Blob/data-source UI is an internal diagnostic surface while chunk
      // upload is being proven — admins (and superusers) only.
      show_blob_controls: !isLoading && (data?.user_role >= 8000 || data?.superuser === true),
      // Resolved per-team feature flags from the profile payload; empty while
      // loading so licensed features stay hidden rather than flashing on.
      privileges: data?.privileges ?? {},
    }),
    [data, viewType, user_role, isLoading],
  );
  return {
    data: memoizedUserData,
    error,
    isLoading,
  };
}
